module.exports = __webpack_public_path__ + "afc4c6dc09c2cefdc6f9b6b48bbc84a7.jpg";